/**
 * Brand glyphs for the social-login buttons. Shaped like lucide icons (accept
 * `size` + `className`) so they drop into CandyButton's `icon` prop. `strokeWidth`
 * is accepted-and-ignored (these are filled marks, not strokes).
 */
export function GoogleIcon({ size = 18, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" className={className} aria-hidden="true">
      <path
        fill="#FFC107"
        d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"
      />
      <path
        fill="#FF3D00"
        d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0124 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 01-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"
      />
    </svg>
  );
}

export function AppleIcon({ size = 18, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M16.365 1.43c0 1.14-.42 2.2-1.12 2.99-.84.95-2.2 1.69-3.34 1.6-.14-1.1.43-2.26 1.07-2.99.78-.88 2.18-1.55 3.39-1.6zM20.5 17.06c-.55 1.27-.82 1.84-1.53 2.96-.99 1.57-2.39 3.52-4.12 3.53-1.54.02-1.93-.99-4.02-.98-2.09.01-2.52.99-4.06.97-1.73-.02-3.05-1.78-4.04-3.34C-.05 16.93-.34 12.05 1.53 9.5c1.06-1.44 2.73-2.35 4.31-2.35 1.6 0 2.61 1 3.94 1 1.29 0 2.07-1 3.93-1 1.4 0 2.89.76 3.95 2.08-3.47 1.9-2.91 6.86.84 7.83z" />
    </svg>
  );
}
